import type { PayloadAction } from '@reduxjs/toolkit';

import type { LicenseState } from './_state.type';

/** License Reducer. */
export const licenseReducer = {
  /**
   * Set is license activated.
   *
   * @param {LicenseState} state State.
   * @param {PayloadAction<boolean>} action Action.
   */
  setIsLicenseActivated: (state: LicenseState, { payload }: PayloadAction<boolean>) => {
    state.license.isActivated = payload;
  },
};
